import { FC } from "react";
import useI18n from "../hooks/useTranslations";
import AccountButton from "./AccountButton";
import styles from "./HeaderBar.module.css";
import Hamburger from "./ui/Hamburger";
import SvgLogo from "./ui/Logo";

type HeaderBarProps = {
  sidebar?: {
    toggle: () => void;
    isOpen: boolean;
  };
};

const HeaderBar: FC<HeaderBarProps> = ({ sidebar }) => {
  const i18n = useI18n();
  return (
    <header className={styles.header}>
      {!!sidebar && <Hamburger onClick={sidebar.toggle} isOpen={sidebar.isOpen}></Hamburger>}
      <div className={styles.logo}>
        <SvgLogo />
      </div>
      <div className={styles.title}>
        {import.meta.env.MODE === "staging" && (
          <span className={styles.mode}>{i18n.translation.common.testEnvironment}</span>
        )}
      </div>
      <AccountButton />
    </header>
  );
};

export default HeaderBar;
